import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { noWhitespaceValidator } from '../../../../shared/src/lib/service/helper.service';
import { AdministratorFacade, Helper } from '@piqet-angular/data';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'piqet-angular-add-city',
  templateUrl: './add-city.component.html',
  styleUrls: ['./add-city.component.css'],
  providers: [TitleCasePipe],
})
export class AddCityComponent {
  modalLabel: any;
  adminCityData: any;
  cityAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  countryList: any;
  selectCountry: any;
  stateList: any;
  selectState: any;
  isDisabledDropDown!: boolean;
  @Output() saveCityEvent = new EventEmitter<any>();

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    public administratorFacade: AdministratorFacade,
    private titleCasePipe: TitleCasePipe,
    public helper: Helper,
    private sharedService: SharedService
  ) {
    this.adminCityData = this.modal?.modalService?.config?.initialState?.['cityData'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.countryList = this.adminCityData.countryItems;
    this.stateList = this.adminCityData.stateItems;
    this.getCountryData();
    this.getStateData();
  }

  ngOnInit(): void {
    this.cityAddEditForm = this.formBuilder.group({
      country: [null, Validators.required],
      state: [null],
      cityName: [this.adminCityData.name || '', [Validators.required, noWhitespaceValidator]],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  setFormData() {
    this.cityAddEditForm.patchValue({ country: this.selectCountry, state: this.selectState });
  }

  async onChange(event: any) {
    if (event) {
      this.stateList = await this.GetStateListByCountryId(event);
    }
    this.cityAddEditForm.controls['state'].setValue(null);
  }

  async GetStateListByCountryId(countryId: any) {
    const stateList = await this.sharedService.getStates(countryId);
    const updatedStateData = stateList.data.map((item: any) => {
      return {
        ...item,
        name: Helper.convertToTitleCaseforState(item.name),
      };
    });
    return updatedStateData;
  }

  async getCountryData() {
    await this.countryList.map((item: any) => {
      if (item.id == this.adminCityData.countryId) {
        return (this.selectCountry = item);
      }
    });
  }

  async getStateData() {
    await this.stateList.map((item: any) => {
      if (item.id == this.adminCityData.stateId) {
        return (this.selectState = item);
      }
    });
  }

  commonInputSearch(term: string, item: any) {
    return item.name?.toLowerCase().includes(term.toLowerCase());
  }

  onSave() {
    this.submitted = true;
    if (
      this.cityAddEditForm.controls['country'].value.name == 'Country' ||
      !this.cityAddEditForm.controls['cityName'].value
    ) {
      return;
    }
    if (this.cityAddEditForm.status == 'VALID') {
      const cityPayload = {
        id: this.adminCityData.id || 0,
        name: this.cityAddEditForm.controls['cityName'].value,
        countryId:
          this.cityAddEditForm.controls['country'].value.id ||
          this.cityAddEditForm.controls['country'].value,
        stateId:
          this.cityAddEditForm.controls['state'].value?.id ||
          this.cityAddEditForm.controls['state']?.value,
      };
      this.saveCityEvent.emit(cityPayload);
      this.onClose();
    }
  }
}
